import { render, staticRenderFns } from "./CoinFrontAndBack.vue?vue&type=template&id=278f2672&scoped=true&"
import script from "./CoinFrontAndBack.vue?vue&type=script&lang=ts&"
export * from "./CoinFrontAndBack.vue?vue&type=script&lang=ts&"
import style0 from "./CoinFrontAndBack.vue?vue&type=style&index=0&id=278f2672&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f2672",
  null
  
)

export default component.exports